export const SubscriptionAddress = "0x744F8ae50E15bCca7AB493B00C00Cd813ef628d4";

export const SubscriptionAbi = [
  { inputs: [], stateMutability: "nonpayable", type: "constructor" },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [{ internalType: "uint256", name: "package", type: "uint256" }],
    name: "CurrentPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "allow", type: "address" }],
    name: "allowToCallBoxFunctions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "boxAddress", type: "address" },
      { internalType: "address", name: "user", type: "address" },
    ],
    name: "autoAllowAccessForSpecificBox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "checkSubscriptionStatus",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "newPrice", type: "uint256" },
      { internalType: "uint256", name: "newStorage", type: "uint256" },
    ],
    name: "createNewSubscriptionPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "allow", type: "address" }],
    name: "disAllowToCallBoxFunctions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "index", type: "uint256" },
    ],
    name: "getBoxMemorybyIndex",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "boxAddress", type: "address" }],
    name: "getRequestedAccessListOfBox",
    outputs: [{ internalType: "address[]", name: "", type: "address[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "package", type: "uint256" }],
    name: "getSubscriptionPlanDetails",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "price", type: "uint256" },
          {
            internalType: "uint256",
            name: "storageAvailable",
            type: "uint256",
          },
        ],
        internalType: "struct Subscription.subscriptionPlans",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getUserAllBoxes",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "price", type: "uint256" },
          {
            internalType: "uint256",
            name: "storageAvailable",
            type: "uint256",
          },
        ],
        internalType: "struct Subscription.subscriptionPlans[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "user", type: "address" }],
    name: "getUserAllBoxesInfo",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint256", name: "price", type: "uint256" },
              {
                internalType: "uint256",
                name: "storageAvailable",
                type: "uint256",
              },
            ],
            internalType: "struct Subscription.subscriptionPlans",
            name: "plan",
            type: "tuple",
          },
          { internalType: "address", name: "boxAddress", type: "address" },
        ],
        internalType: "struct Subscription.userBoxDetails[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "user", type: "address" },
      { internalType: "uint256", name: "index", type: "uint256" },
    ],
    name: "getUserBoxByIndex",
    outputs: [
      {
        components: [
          {
            components: [
              { internalType: "uint256", name: "price", type: "uint256" },
              {
                internalType: "uint256",
                name: "storageAvailable",
                type: "uint256",
              },
            ],
            internalType: "struct Subscription.subscriptionPlans",
            name: "plan",
            type: "tuple",
          },
          { internalType: "address", name: "boxAddress", type: "address" },
        ],
        internalType: "struct Subscription.userBoxDetails",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    name: "packages",
    outputs: [
      { internalType: "uint256", name: "price", type: "uint256" },
      { internalType: "uint256", name: "storageAvailable", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "boxAddress", type: "address" },
      { internalType: "address", name: "user", type: "address" },
    ],
    name: "rejectAllowAccessForSpecificBox",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
    name: "removeSubscriptionPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "package", type: "uint256" }],
    name: "subscribe",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSubscriptionPlans",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "index", type: "uint256" },
      { internalType: "uint256", name: "newPrice", type: "uint256" },
      { internalType: "uint256", name: "newStorage", type: "uint256" },
    ],
    name: "updateSubscriptionPlan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
